import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import axiosInstance from "../../../lib/axios";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
  Tab,
  Add,
} from "@mui/icons-material";
import {
  Stepper,
  Step,
  StepLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import CustomAutocomplete from '../../../Components/AutoComplete/AutoComplete';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import AuthHeader from "../../../Auth";
import useResizeObserver from '../../../atoms/Resize/useResizeObserver';
import UnLock from "../../../GlobalFunction/UnLock";

const StepperMst2 = ({ TableData, mode, Cities, setTableData, AllfieldStepperData, CompanyId, setActiveStep, fetchCompanyData, viewModeDis, addModeDis, setFlag, IsButtonSubmit, UserLoginId, TextDisabledFast }) => {
  const { register, watch, reset, setValue } = useForm();
  const navigate = useNavigate();
  const [AllTextDisabled, setAllTextDisabled] = useState(false);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(true);
  const [IndexofSelect, setIndexofSelect] = useState(0);
  const [InternalMode, setInternalMode] = useState("add");
  const [PinCity, setPinCity] = useState([]);
  const [AddDisabled, setAddDisabled] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [selectedImage, setselectedImage] = useState("");
  // const [Status, setStatus] = useState(" ");
  const divRef = useRef(null)
  // useEffect(() => {

  // const divRef = useRef(null); // Create a reference for the element you want to observe

  // // Use the custom hook, passing the ref
  // useResizeObserver(divRef);
  // })



  useEffect(() => {
    const observer = new ResizeObserver(() => {
      console.log('Resized!', divRef.current);
    });

    // Observe the div element
    if (divRef.current) {
      observer.observe(divRef.current);
    }

    // Cleanup observer on unmount
    return () => {
      if (divRef.current) {
        observer.unobserve(divRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (PinCity.length > 0) {
      handlePinIdChange();
    }
  }, [PinCity])

  useEffect(() => {

    if (IndexofSelect === -1) return;
    if (mode === "add") {
      // let obj = TableData[IndexofSelect];
      // for (let key in obj) {
      //   setValue(key, TableData[IndexofSelect][key]);
      // }
      settingValue();
      handlePincodeChange();

    } else {

      // console.log("hii");
      // settingValue();
      // let PinCodeObj = { target: { value: TableData[IndexofSelect]['PinCode'] } };
      // handlePincodeChange();
      // setValue('PinID', TableData[IndexofSelect]['PinID']);
      if (TableData && TableData.length > 0) {
        console.log("hii");
        settingValue();
        let PinCodeObj = { target: { value: TableData[IndexofSelect]['PinCode'] } };
        handlePincodeChange();
        setValue('PinID', TableData[IndexofSelect]['PinID']);
      }

    }
    setAllTextDisabled(true);
  }, [IndexofSelect, TableData]);

  const columns = [
    { id: "CobrMstId", label: "BrId", minWidth: 50 },
    { id: "DBFLAG", label: "Flag", minWidth: 50 },
    { id: "CobrName", label: "BranchName", minWidth: 50 },
    { id: "GSTIN", label: "GstNo", minWidth: 50 },
    { id: "PinCode", label: "Pincode", minWidth: 50 },
    { id: "CobrMob", label: "MobileNo", minWidth: 50 },
    { id: "CobrEmail", label: "Email", minWidth: 50 },
    { id: "MainBranch", label: "Main", minWidth: 30 },

  ];

  const settingValue = () => {
    console.log("TableData", TableData);
    let obj = TableData[IndexofSelect];
    for (let key in obj) {
      setValue(key, TableData[IndexofSelect][key]);
    }
    setselectedImage(TableData[IndexofSelect]['CobrLogo'])
    // setStatus(TableData[IndexofSelect]['Status'])

  }

  const handlePreviousClick = () => {

    if (!(!AllButtonDisabled || !AddDisabled)) {
      toast.info("Please Confirm Or Cancel The Request");
      console.log(!AllButtonDisabled || !AddDisabled);
      return;
    }


    if (mode === "view") {

    } else {
      addModeDis();
      setFlag(true);

    }
    setActiveStep(0);
  }

  const resetFunc = () => {

    reset({
      CityId: "",
      CobrAbrv: "",
      CobrAdd: "",
      CobrEmail: "",
      CobrMstId: "",
      CobrName: "",
      CobrTel: "",
      GSTIN: "",
      IeCode: "",
      MsmeCat: "",
      MsmeNo: "",
      MsmeType: "",
      Remark1: "",
      Remark2: "",
      Website: "",
      CobrMob: '',
      PinID: "",
      PinCode: "",
      CobrLogo: "",
    });
    setselectedImage("");
  };

  const handleClickAdd = () => {
    setInternalMode("Add");
    setAllTextDisabled(false);
    resetFunc();
    setIndexofSelect(-1);
    setAllButtonDisabled(true);
    setAddDisabled(true);
  };

  const handleClickEdit = () => {
    setInternalMode("Edit")
    setAllTextDisabled(false);
    setAllButtonDisabled(true);
    setAddDisabled(true);
  };

  const handleRowClick = (rowIndex) => {
    setIndexofSelect(rowIndex);
    if (rowIndex == 0) {
      setAddDisabled(false);
      setAllButtonDisabled(true);
      setAllTextDisabled(true);
      return;
    }
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
  };

  const handleClickConfirm = () => {
    let obj = watch();
    console.log(obj);

    if (obj.CobrName === "" || obj.PinCode === "" || obj.CityId === "" || 
         obj.CobrAbrv === "" || obj.PinID === "") {
      toast.info("Plz Filled the Data");
      return;
    };

    obj.CityId = parseInt(obj.CityId);
    obj.PinID = parseInt(obj.PinID);

    let branchName = obj.CobrName;
    let duplicateInd = TableData.findIndex((obj => obj.CobrName === branchName));


    if (InternalMode === "Add") {
      if (duplicateInd < 0) {
        obj.CobrMstId = 0;
        obj.DBFLAG = "I";
        obj.Status = "1";
        obj.MainBranch = "0";
        obj.CobrLogo = selectedImage;
        let newTabData = [...TableData];
        newTabData.push(obj);
        setTableData(newTabData);
      } else {
        toast.error("Duplicate Name");
      }
    } else {
      TableData[IndexofSelect].DBFLAG === "I" ? obj.DBFLAG = "I" : obj.DBFLAG = "U";
      let TabData = [...TableData];
      for (let key in obj) {
        TabData[IndexofSelect][key] = obj[key];
      }
      TabData[IndexofSelect]['CobrLogo'] = selectedImage;
      setTableData(TabData);


    }
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
    handleRowClick(0);



    // if (duplicateInd < 0) {
    //   if (InternalMode === "Add") {
    //     obj.CobrMstId = 0;
    //     obj.DBFLAG = "I";
    //     obj.Status = "1";
    //     obj.MainBranch = "0";
    //     let newTabData = [...TableData];
    //     newTabData.push(obj);
    //     setTableData(newTabData);
    //   } else {
    //     TableData[IndexofSelect].DBFLAG === "I" ? obj.DBFLAG = "I" : obj.DBFLAG = "U";
    //     let TabData = [...TableData];
    //     for (let key in obj) {
    //       TabData[IndexofSelect][key] = obj[key];
    //     }
    //     setTableData(TabData);
    //   }
    //   setAllButtonDisabled(false);
    //   setAllTextDisabled(true);
    // } else {
    //   toast.error("Duplicate Name")
    // }
  };



  const handleDelete = () => {
    setopenDialog(true);

  }

  const handleCancel = () => {
    setopenDialog(false);
  }
  const handleConfirmDelete = () => {
    console.log(IndexofSelect);
    let TabData = [...TableData];
    let flag = TableData[IndexofSelect].DBFLAG;
    if (flag === "U" || flag === "R") {
      TabData[IndexofSelect].DBFLAG = "D";
    } else if (flag === "I") {
      TabData = TableData.filter((obj, index) => index !== IndexofSelect);
      setAddDisabled(false);
      setAllButtonDisabled(true);
      setAllTextDisabled(true);
      setIndexofSelect(0);
    }
    setTableData(TabData);
    setopenDialog(false);
  }



  const handleClickCancel = () => {
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
    resetFunc();
    if (TableData.length > 1) {
      if (IndexofSelect === 1) {
        settingValue();
      }
      setIndexofSelect(1);
    } else {
      if (IndexofSelect === 0) {
        settingValue();
      }
      setAddDisabled(false);
      setAllButtonDisabled(true);
      setAllTextDisabled(true);
      setIndexofSelect(0);
    }
  };

  const handlePincodeChange = async () => {
    if (watch('PinCode') === undefined || watch('PinCode') === '') return;
    let value = watch("PinCode");
    console.log("value", value);
    if (value.trim().length === 6) {
      try {
        const response = await axiosInstance.post(
          `pincodeMst/getdrppincodewisearea`,
          {
            PinCode: parseInt(value),
          },

        );
        const data = response.data.Data;

        if (data && data.length > 0) {
          setPinCity(data);
        } else {
          setPinCity([]);
        }
      } catch (error) {
        console.error("Error fetching pin code data:", error);
      }
    } else {
      setValue("City", "");
      setValue("State", "");
      setPinCity([]);
    }

  }


  const handlePinIdChange = async () => {
    console.log('PinId', watch('PinID'));
    console.log('PinCity', PinCity);
    if (watch('PinID') === undefined || watch('PinID') === '') return;
    let getObj = PinCity.find(obj => obj.Id === watch('PinID'));
    console.log("getobj ", getObj);
    let AreaName = getObj?.Name;
    let PinCode = getObj?.PinCode;
    if (getObj) {
      try {
        const response = await axiosInstance.post(
          `pincodeMst/getdrppincodeAreawise_datafill`,
          {
            AreaName,
            PinCode
          },

        );
        const data = response.data.Data;
        console.log("pindata", data);
        if (data && data.length > 0) {
          setValue('City', data[0].CityName);

        } else {

        }
      } catch (error) {
        console.error("Error fetching pin code data:", error);
      }
    }

  }




  const handleSubmit = async () => {

    if (!(!AllButtonDisabled || !AddDisabled)) {
      toast.info("Please Confirm Or Cancel The Request");
      console.log(!AllButtonDisabled || !AddDisabled);
      return;
    }
    TextDisabledFast(true);

    if (mode === "add") {

      if (AllfieldStepperData.hasOwnProperty("area")) {
        delete AllfieldStepperData.area;
      }
      if (AllfieldStepperData.hasOwnProperty("PinId")) {
        delete AllfieldStepperData.area;
      }
      AllfieldStepperData.DBFLAG = "I";
      AllfieldStepperData.Status = (AllfieldStepperData.Status === "1") ? "1" : "0";
      AllfieldStepperData.PinID = parseInt(AllfieldStepperData.PinID);
      AllfieldStepperData.CityId = parseInt(AllfieldStepperData.CityId);
      AllfieldStepperData.MsmeCat.trim()
      AllfieldStepperData.MsmeType.trim()
      AllfieldStepperData.CreatedBy = parseInt(UserLoginId);
      // AllfieldStepperData.cobrMstList = TableData;
      AllfieldStepperData.CobrMstList = [...TableData];



      let FormattedObj = JSON.stringify(AllfieldStepperData).replace(/"/g, '\\"');
      FormattedObj = '"' + FormattedObj + '"';
      console.log("AllfieldStepperData", FormattedObj);

      // const myHeaders = {
      //   "Content-Type": "application/json"
      // };
      try {
        let response = await axiosInstance.post(
          `CoMst/ManageCompanyBranch`,
          FormattedObj,

        );
        console.log("response", response);
        toast.success(response.data.Message, { autoClose: 1000 });
        setTimeout(() => {
          fetchCompanyData(1, "L");
          setActiveStep(0);
        }, 0);
        // setTimeout(() => {
        //   navigate(`/masters/companytable`);
        // }, 1800);
      } catch (err) {
        console.log("err", err);
      }
      //   try{
      //   let response  = await axios.post(
      //     `${process.env.REACT_APP_API_URL}CoMst/ManageCompanyBranch`,
      //     FormattedObj
      //   );
      //   console.log("response",response);
      // }
      // catch(err){
      //    console.log("err",err);
      // }

    } else {
      if (AllfieldStepperData.hasOwnProperty("area")) {
        delete AllfieldStepperData.area;
      }
      AllfieldStepperData.DBFLAG = "U";
      AllfieldStepperData.Status = (AllfieldStepperData.Status === "1") ? "1" : "0";
      AllfieldStepperData.CoMstId = CompanyId;
      AllfieldStepperData.PinID = parseInt(AllfieldStepperData.PinID);
      AllfieldStepperData.CityId = parseInt(AllfieldStepperData.CityId);
      AllfieldStepperData.MsmeCat = AllfieldStepperData.MsmeCat.trim()
      AllfieldStepperData.MsmeType.trim()
      AllfieldStepperData.UpdatedBy = parseInt(UserLoginId);
      // AllfieldStepperData.cobrMstList = TableData;

      AllfieldStepperData.CobrMstList = [...TableData];



      console.log("AllfieldStepperData", AllfieldStepperData);
      let FormattedObj = JSON.stringify(AllfieldStepperData).replace(/"/g, '\\"');
      FormattedObj = '"' + FormattedObj + '"';

      // const myHeaders = {
      //   "Content-Type": "application/json"
      // };
      try {
        let response = await axiosInstance.post(
          `CoMst/ManageCompanyBranch`,
          FormattedObj,

        );
        toast.success(response.data.Message, { autoClose: 1000 });
        console.log("response", response);
        if (response.data.Status === 0) {

          let Flag = await UnLock(CompanyId, "MstCo", "CoMstId");
          console.log(Flag);
          switch (Flag) {
            case 0: break;
            case 1: toast.info("Problem To Unlocked Record", { autoClose: 500 });
              break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });
          }
          setTimeout(() => {
            fetchCompanyData(CompanyId, "R");
            setActiveStep(0);
          }, 0);
        }
      } catch (err) {
        console.log("err", err);
      }
    }
  }

  const handleClickCancelButton = async () => {


    if (mode === "view") {
      let Flag = await UnLock(CompanyId, "MstCo", "CoMstId");
      console.log(Flag);
      switch (Flag) {
        case 0: break;
        case 1: toast.info("Problem To Unlocked Record", { autoClose: 500 });
          break;
        default: toast.info("Something Went Wrong", { autoClose: 500 });
      }
    }
    // viewModeDis();
    CompanyId != -1 ? await fetchCompanyData(CompanyId, "R") : await fetchCompanyData(1, "L");
    setActiveStep(0);


  }


  const handleFileChange = (event) => {
    console.log("obj", watch());
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      readFileAsBase64(file)
        .then(base64String => {
          console.log("base64String", base64String);
          setValue('CoLogo', base64String);
          setselectedImage(base64String);
        })
        .catch(err => {
          console.error('Error reading file:', err);
          toast.error('Error reading file. Please try again.');
        });
    }
  };

  return (
    <Grid container spacing={2}>
      {/* <ToastContainer /> */}
      <Dialog
        open={openDialog}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCancel}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* Table Section */}
      <Grid item xs={12} >
        <Paper
          sx={{
            width: "90%",
            overflow: "hidden",
            margin: "0px 0px 0px 50px",
            border: "1px solid lightgray",
          }}
        >
          <TableContainer sx={{ maxHeight: 450 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow sx={{ "& > th": { padding: "2px 10px" } }}>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      <Typography variant="subtitle1" fontWeight="bold">
                        {column.label}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {TableData?.map((row, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      "& > td": { padding: "2px 14px" },
                      cursor: "pointer",
                    }}
                    onClick={() => handleRowClick(index)}
                  >
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {value || "N/A"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>

      {/* Buttons */}
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          marginTop: "-10px",
          paddingRight: "100px",
        }}
      >
        <Box sx={{
          marginLeft: "50px"
        }}>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff" }}
            onClick={handleClickAdd}
            disabled={AllButtonDisabled && AddDisabled || IsButtonSubmit}
          >
            <AddIcon />
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
            disabled={AllButtonDisabled || IsButtonSubmit}
            onClick={handleClickEdit}
          >
            <EditIcon />
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff" }}
            disabled={AllButtonDisabled || IsButtonSubmit}
            onClick={handleDelete}
          >
            <DeleteIcon />
          </Button>
        </Box>
        <Box>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff" }}
            disabled={!AllButtonDisabled || !AddDisabled}
            onClick={handleClickConfirm}
          >
            Confirm
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
            disabled={!AllButtonDisabled || !AddDisabled}
            onClick={handleClickCancel}
          >
            Cancel
          </Button>
        </Box>
      </Grid>

      {/* Form Section */}
      <Grid container spacing={1} sx={{ margin: "auto", paddingLeft: "65px", justifyContent: 'center', alignItems: 'center' }} >
        <Grid container spacing={2} >
          <Grid item lg={8} md={8} xs={12}  >
            <Box display="flex" flexDirection="column" gap={0.5} >

              <Grid container spacing={0.5} >
                <Grid item xs={12} md={1}>
                  <TextField
                    fullWidth
                    label="Code"
                    name="branchCode"
                    variant="filled"
                    className="custom-textfield"
                    {...register("CobrMstId")}
                    disabled={AllTextDisabled}
                    value={watch('CobrMstId') || ''}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    // label="Short Name"
                    label={
                      <span>
                        Short Name <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="shortName"
                    variant="filled"
                    className="custom-textfield"
                    {...register("CobrAbrv")}
                    value={watch('CobrAbrv') || ''}
                    disabled={AllTextDisabled}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        Branch Name <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    variant="filled"
                    className="custom-textfield"
                    {...register("CobrName")}
                    value={watch('CobrName') || ''}
                    disabled={AllTextDisabled}
                  />
                </Grid>
                {/* <Grid item xs={12} md={3}>
                
                  <select
                    id="jurisdiction"
                    name="jurisdiction"
                    {...register("CityId")}
                    value={watch("CityId")}
                    style={{
                      height: "42px",
                      width: "14vw",
                      borderColor: "gray",
                      borderRadius: "5px",
                      padding: "0 10px",
                      fontSize: "16px",
                      color: "gray",
                    }}
                    disabled={AllTextDisabled} 
                  >
                  
                    <option value="" disabled className="custom-textfield">
                      Select Jurisdiction{" "}
                      <span style={{ color: "red" }}>*</span>
                    </option>

                   
                    {Cities?.map((option) => (
                      <option key={option.Id} value={option.Id}>
                        {option.Name}
                      </option>
                    ))}
                  </select>
                </Grid> */}
                <Grid item xs={12} md={3} className='form_field'>
                  {/* <FormControl variant="filled" fullWidth className="custom-select">
                    <InputLabel id="areaName-select-label">Juridiction  <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Select
                      labelId="areaName-select-label"
                      id="CityId"
                      name="CityId"
                      value={watch('CityId') || ""}
                      className="custom-textfield"
                      disabled={AllTextDisabled}
                      {...register("CityId")}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            overflow: 'auto',
                          },
                        },
                      }}

                    >

                      {Cities.length > 0 && Cities.map(obj =>
                        <MenuItem value={obj.Id} key={obj.Id} >
                          {obj.Name}
                        </MenuItem>

                      )}


                    </Select>
                  </FormControl> */}

                  <CustomAutocomplete
                    options={Cities}
                    id="CityId-autocomplete"
                    name='CityId'
                    label={
                      <span>
                        Juridiction <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    value={Cities.find((city) => city.Id === watch("CityId")) || null}
                    {...register("CityId")}
                    disabled={AllTextDisabled}
                    
                  />
                </Grid>
              </Grid>
              <Grid container spacing={0.5}>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="GST No"
                    variant="filled"
                    className="custom-textfield"
                    {...register("GSTIN")}
                    value={watch('GSTIN') || ''}
                    disabled={AllTextDisabled}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="IE Code"
                    variant="filled"
                    className="custom-textfield"
                    {...register("IeCode")}
                    value={watch('IeCode') || ''}
                    disabled={AllTextDisabled}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Email ID"
                    variant="filled"
                    className="custom-textfield"
                    {...register("CobrEmail")}
                    value={watch('CobrEmail') || ''}

                    disabled={AllTextDisabled}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Tel No"
                    variant="filled"
                    className="custom-textfield"
                    {...register("CobrTel")}
                    value={watch('CobrTel') || ''}
                    disabled={AllTextDisabled}
                  />
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} xs={12}>
                {/* <Grid container spacing={3}> */}
                <Box display="flex" flexDirection="column" gap={1}>
                  <Grid container spacing={0.5}>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label="Mob Num"
                        variant="filled"
                        className="custom-textfield"
                        {...register("CobrMob")}
                        value={watch('CobrMob') || ''}
                        disabled={AllTextDisabled}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label="MSME No"
                        variant="filled"
                        className="custom-textfield"
                        {...register("MsmeNo")}
                        disabled={AllTextDisabled}
                        value={watch('MsmeNo') || ''}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      {/* <TextField
                        fullWidth
                        label="MSME Cat"
                        variant="filled"
                        className="custom-textfield"
                        {...register("MsmeCat")}
                        value={watch('MsmeCat') || ''}
                        disabled={AllTextDisabled}
                      /> */}

                      <FormControl variant="filled" fullWidth className="custom-select">
                        <InputLabel id="areaName-select-label">MSME Cat</InputLabel>
                        <Select
                          labelId="areaName-select-label"
                          id="MsmeCat"
                          name="MsmeCat"
                          value={watch('MsmeCat') || ""}
                          className="custom-textfield"
                          disabled={AllTextDisabled}
                          {...register("MsmeCat")}
                        >

                          <MenuItem value={"M"}>Micro</MenuItem>
                          <MenuItem value={"N"}>Medium</MenuItem>
                          <MenuItem value={"S"}>Small</MenuItem>



                        </Select>
                      </FormControl>


                    </Grid>
                    <Grid item xs={12} md={3}>
                      {/* <TextField
                        fullWidth
                        label="MSME Type"
                        variant="filled"
                        className="custom-textfield"
                        {...register("MsmeType")}
                        value={watch('MsmeType') || ''}
                        disabled={AllTextDisabled}
                      /> */}


                      <FormControl variant="filled" fullWidth className="custom-select">
                        <InputLabel id="areaName-select-label">MSME Type</InputLabel>
                        <Select
                          labelId="areaName-select-label"
                          id="MsmeType"
                          name="MsmeType"
                          value={watch('MsmeType') || ""}
                          className="custom-textfield"
                          disabled={AllTextDisabled}
                          {...register("MsmeType")}
                        >

                          <MenuItem value={"M"}>Manufacturing</MenuItem>
                          <MenuItem value={"S"}>Service</MenuItem>




                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label={
                          <span>
                            Pincode Code  <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        name="pinCode"
                        variant="filled"
                        className="custom-textfield"
                        {...register("PinCode", { onChange: handlePincodeChange })}
                        value={watch('PinCode') || ''}
                        disabled={AllTextDisabled}
                      />
                    </Grid>
                    <Grid item xs={12} md={3} className='form_field'>
                      <FormControl variant="filled" fullWidth className="custom-select">
                        <InputLabel id="areaName-select-label">Area  <span style={{ color: 'red' }}>*</span></InputLabel>
                        <Select
                          labelId="areaName-select-label"
                          id="PinID"
                          name="PinID"
                          value={watch('PinID') || ""}
                          className="custom-textfield"
                          disabled={AllTextDisabled}
                          {...register("PinID", { onChange: handlePinIdChange })}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 200, // Set the maximum height for the dropdown menu
                                overflow: 'auto', // Allow scrolling if content exceeds the max height
                              },
                            },
                          }}
                        >

                          {PinCity.length > 0 && PinCity.map(obj =>
                            <MenuItem value={obj.Id} key={obj.Id} >
                              {obj.Name}
                            </MenuItem>

                          )}

                          <MenuItem value="2" >
                            No areas available
                          </MenuItem>

                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label="City"
                        name="City"
                        variant="filled"
                        className="custom-textfield"
                        {...register("City")}
                        disabled={AllTextDisabled}
                        value={watch('City') || ""}
                      />
                    </Grid>

                    {/* Remark2 Field */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label="Website"
                        variant="filled"
                        className="custom-textfield"
                        {...register("Website")}
                        value={watch('Website') || ''}
                        disabled={AllTextDisabled}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Address"
                        name="branchAddress"
                        multiline
                        rows={1}
                        variant="filled"
                        className="custom-textfield"
                        {...register("CobrAdd")}
                        value={watch('CobrAdd') || ''}
                        disabled={AllTextDisabled}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Bank Details1"
                        name="bankDetails1"
                        multiline
                        rows={1}
                        variant="filled"
                        className="custom-textfield"
                        {...register("Remark1")}
                        value={watch('Remark1') || ''}
                        disabled={AllTextDisabled}
                      />
                    </Grid>
                    {/* <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Bank Details2"
                  name="bankDetails2"
                  multiline
                  rows={1}
                  variant="filled"
                  className="custom-textfield"
                  {...register("Remark2")}
                  disabled={AllTextDisabled}
                />
                </Grid> */}
                  </Grid>
                </Box>
              </Grid>
            </Box>
          </Grid>
          <Grid
            item
            lg={2}
            md={2}
            xs={12}
            display="flex"

            justifyContent="center"


          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              border="1px solid #ccc"
              borderRadius={1}
              width={150}
              height={145}
              overflow="hidden"
              position="relative"
              sx={{ cursor: "pointer" }}
            >
              {selectedImage ? (
                <img
                  src={selectedImage}
                  alt="Uploaded Logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <Typography variant="body2" color="textSecondary">
                  Browse
                </Typography>
              )}

              <input
                id="upload-photo"
                type="file"
                accept="image/*"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                }}
                {...register('CoLogo')}
                onChange={handleFileChange}
                disabled={AllTextDisabled}
              />
            </Box>
            <label htmlFor="upload-photo">
              <Button
                component="span"
                style={{ marginTop: '5px' }}
              >
                Upload Image
              </Button>
            </label>
          </Grid>







        </Grid>

      </Grid>








      <Grid
        item
        ref={divRef}
        xs={2}
        className="form_button"
        sx={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          marginTop: "10px",
          marginLeft: "69vw",
          textAlign: "right"

        }}
      >
        {['Prev', 'Submit', 'Cancel'].map((label, index) => (
          <Button
            key={index}
            sx={{ background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)', width: "50px" }}
            variant="contained"
            onClick={label === 'Prev' ? handlePreviousClick : label === 'Submit' ? handleSubmit : handleClickCancelButton}
            disabled={IsButtonSubmit}
          >
            {label}
          </Button>
        ))}
      </Grid>
    </Grid>
  );
};

export default StepperMst2;
